{
  "name": "shell-online",
  "version": "0.25.0",
  "description": "Turn any terminal process into a collaborative browser link.",
  "private": true,
  "license": "MIT",
  "homepage": "https://shell.online",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/TeoSlayer/shell.online.git"
  },
  "bugs": {
    "url": "https://github.com/TeoSlayer/shell.online/issues"
  },
  "engines": {
    "node": ">=22"
  },
  "type": "module",
  "scripts": {
    "build": "npm run check && npm run build:web && npm run build:cli && npm run verify:downloads",
    "build:cli": "sh ./scripts/build-cli.sh",
    "build:web": "vite build",
    "build:standalone": "npm run build:web && esbuild standalone/server.ts --bundle --platform=node --format=esm --target=node22 --external:ws --outfile=standalone/dist/server.mjs",
    "start:standalone": "node standalone/dist/server.mjs",
    "deploy:production": "node ./scripts/deploy-production.mjs",
    "verify:downloads": "node ./scripts/verify-downloads.mjs",
    "check": "npm run typecheck && npm test",
    "test": "vitest run && sh ./scripts/test-install.sh && sh ./scripts/test-docker-entrypoint.sh && sh ./scripts/test-deploy-production.sh && sh ./scripts/test-qemu-linux.sh --check && node ./scripts/test-landing-seo.mjs && node ./scripts/test-mobile-controls.mjs && node ./scripts/check-formula.mjs",
    "test:qemu:manifest": "sh ./scripts/test-qemu-linux.sh --check",
    "test:terminal-snapshot": "node scripts/test-terminal-snapshot.mjs",
    "typecheck": "tsc -p tsconfig.worker.json --noEmit && tsc -p tsconfig.web.json --noEmit && tsc -p tsconfig.standalone.json --noEmit",
    "test:app": "npm --prefix app ci && npm --prefix app test",
    "verify:published": "node ./scripts/verify-published.mjs",
    "check:published": "node ./scripts/check-published-downloads.mjs",
    "preflight:staging": "node ./scripts/preflight-staging-config.mjs",
    "preflight:production": "node ./scripts/preflight-staging-config.mjs wrangler.production.jsonc",
    "deploy:staging": "node ./scripts/deploy-staging.mjs"
  },
  "dependencies": {
    "@xterm/xterm": "^6.0.0",
    "mermaid": "12.0.0",
    "ws": "^8.21.3",
    "@modelcontextprotocol/server": "^2.0.0",
    "@xterm/headless": "^6.0.0",
    "agents": "^0.24.0",
    "jose": "^6.2.12",
    "zod": "^4.6.5"
  },
  "overrides": {
    "lodash-es": "4.18.1"
  },
  "devDependencies": {
    "@cloudflare/workers-types": "^5.20260916.1",
    "@types/node": "^26.6.1",
    "@types/ws": "^8.18.1",
    "esbuild": "^0.28.2",
    "typescript": "^7.0.2",
    "vite": "^8.3.0",
    "vitest": "^5.0.1",
    "wrangler": "^4.132.0",
    "jsonc-parser": "3.2.0"
  }
}
